// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Historial de pedidos de una referencia. Todo acotado a .reference-history: el CSS de CRA es
   global y este componente se pinta en pantallas con estilos muy distintos. */

.reference-history { display: inline-flex; flex-wrap: wrap; gap: 4px; }

.reference-history-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 2px 9px;
  border: none;
  border-radius: 10px;
  background: #e4f0e9;
  color: #1e7e4f;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.reference-history-btn:hover,
.reference-history-btn.abierto { background: #d3e8dd; }

.reference-history-veces {
  font-weight: 400;
  font-size: 11px;
  color: #3d6b53;
  border-left: 1px solid #b9d8c7;
  padding-left: 7px;
  white-space: nowrap;
}

.reference-history-lista {
  flex-basis: 100%;
  /* dentro de una fila etiqueta/valor el contenedor es estrecho: que no se encajone */
  min-width: 230px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 190px;
  overflow-y: auto;
  margin-top: 2px;
  padding: 6px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  background: #fbfcfd;
}

.reference-history-vacio { font-size: 12px; color: #777; padding: 2px 4px; }

.reference-history .reference-history-pedido {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 4px 7px;
  border: none;
  border-radius: 5px;
  background: none;
  font-size: 12px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.reference-history .reference-history-pedido:hover { background: #eef4fa; }
.reference-history-num { color: #2c3e50; font-weight: 500; }
.reference-history-fecha { color: #8a94a0; white-space: nowrap; }
`, "",{"version":3,"sources":["webpack://./src/components/common/ReferenceHistory.css"],"names":[],"mappings":"AAAA;8EAC8E;;AAE9E,qBAAqB,oBAAoB,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAEtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;iCACiC,mBAAmB,EAAE;;AAEtD;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oFAAoF;EACpF,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE3E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qDAAqD,mBAAmB,EAAE;AAC1E,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;AAC3D,2BAA2B,cAAc,EAAE,mBAAmB,EAAE","sourcesContent":["/* Historial de pedidos de una referencia. Todo acotado a .reference-history: el CSS de CRA es\n   global y este componente se pinta en pantallas con estilos muy distintos. */\n\n.reference-history { display: inline-flex; flex-wrap: wrap; gap: 4px; }\n\n.reference-history-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 2px 9px;\n  border: none;\n  border-radius: 10px;\n  background: #e4f0e9;\n  color: #1e7e4f;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.reference-history-btn:hover,\n.reference-history-btn.abierto { background: #d3e8dd; }\n\n.reference-history-veces {\n  font-weight: 400;\n  font-size: 11px;\n  color: #3d6b53;\n  border-left: 1px solid #b9d8c7;\n  padding-left: 7px;\n  white-space: nowrap;\n}\n\n.reference-history-lista {\n  flex-basis: 100%;\n  /* dentro de una fila etiqueta/valor el contenedor es estrecho: que no se encajone */\n  min-width: 230px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-height: 190px;\n  overflow-y: auto;\n  margin-top: 2px;\n  padding: 6px;\n  border: 1px solid #e4e4e4;\n  border-radius: 8px;\n  background: #fbfcfd;\n}\n\n.reference-history-vacio { font-size: 12px; color: #777; padding: 2px 4px; }\n\n.reference-history .reference-history-pedido {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  padding: 4px 7px;\n  border: none;\n  border-radius: 5px;\n  background: none;\n  font-size: 12px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.reference-history .reference-history-pedido:hover { background: #eef4fa; }\n.reference-history-num { color: #2c3e50; font-weight: 500; }\n.reference-history-fecha { color: #8a94a0; white-space: nowrap; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
